module.exports = __webpack_public_path__ + "img/logo.825f8781.svg";